<template>
  <div class="mobile-home">
    <!-- 内容区域 -->
    <div class="content">
      <MobileTrackQuery v-if="activeTab === 'track'" />
      <div v-else-if="activeTab === 'mine'" class="mine-page">
        <div class="mine-info">
          <div class="mine-avatar">👤</div>
          <div class="mine-name">{{ userName }}</div>
        </div>
        <el-button type="danger" size="small" @click="onLogout" style="margin-top: 20px;">
          退出登录
        </el-button>
        <button v-if="pcSwitchable" class="pc-switch-btn" type="button" @click="onSwitchPc">切换到电脑版</button>
      </div>
    </div>

    <!-- 底部导航栏 -->
    <div class="tab-bar">
      <div
        class="tab-item"
        :class="{ active: activeTab === 'track' }"
        @click="activeTab = 'track'"
      >
        <div class="tab-icon">📦</div>
        <div class="tab-text">查件</div>
      </div>
      <div
        class="tab-item"
        :class="{ active: activeTab === 'mine' }"
        @click="activeTab = 'mine'"
      >
        <div class="tab-icon">👤</div>
        <div class="tab-text">我的</div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import MobileTrackQuery from './MobileTrackQuery.vue'

export default {
  name: 'MobileHome',
  components: {
    MobileTrackQuery
  },
  props: {
    pcSwitchable: {
      type: Boolean,
      default: false
    }
  },
  emits: ['logout', 'switchPc'],
  setup(_, { emit }) {
    const activeTab = ref('track')
    const userName = ref(localStorage.getItem('userName') || '用户')

    const onLogout = () => {
      emit('logout')
    }

    const onSwitchPc = () => {
      emit('switchPc')
    }

    return {
      activeTab,
      userName,
      onLogout,
      onSwitchPc
    }
  }
}
</script>

<style scoped>
.mobile-home {
  display: flex;
  flex-direction: column;
  /* 100dvh 动态视口：移动端浏览器地址栏展开/收起时跟随实际可见高度，
     避免内容底部预留区落入工具栏下方不可达区域（旧浏览器不支持时回退 100vh） */
  height: 100vh;
  height: 100dvh;
  background: #f5f5f5;
}

.content {
  flex: 1;
  overflow-y: auto;
  /* 预留底部导航栏的高度（图标+文字+内边距约58px，留余量取64px）+ iOS安全区，防止最后一条内容被遮挡 */
  padding-bottom: calc(64px + env(safe-area-inset-bottom));
}

.tab-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 8px 0;
  padding-bottom: env(safe-area-inset-bottom, 8px);
  background: #fff;
  border-top: 1px solid #eee;
  z-index: 100;
}

.tab-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  flex: 1;
}

.tab-icon {
  font-size: 22px;
  margin-bottom: 2px;
}

.tab-text {
  font-size: 11px;
  color: #999;
}

.tab-item.active .tab-icon,
.tab-item.active .tab-text {
  color: #1890ff;
}

.mine-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px;
}

.mine-info {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.mine-avatar {
  font-size: 48px;
  margin-bottom: 12px;
}

.mine-name {
  font-size: 16px;
  color: #333;
}

.pc-switch-btn {
  margin-top: 16px;
  padding: 8px 24px;
  border: 1px solid #1890ff;
  border-radius: 20px;
  background: #fff;
  color: #1890ff;
  font-size: 14px;
  cursor: pointer;
}

.pc-switch-btn:hover {
  background: #e6f7ff;
}
</style>
